import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Header from '../Header';

import { getStrategyRecent, getStrategy } from '../../../utils/apiMiniWidget';
import Strategy from '../../views/Strategy/Strategy';
import { Audiencias } from '../../../../assets/images/index';
import { StyledBoxInside, StyledTitleWidget, StyledWrapper } from './style';
import { SearchByDate } from '../../views/SearchByDate';

const defaultTextForNow = 'No existen datos para el día seleccionado.';

class StrategyPage extends Component {
  constructor(props) {
    super(props);
    this.state = { recent: undefined, now: undefined };
    this.dateSelected = undefined;
  }

  componentDidMount() {
    getStrategy(moment().format('YYYY-MM-DD'))
      .then(strategyNowData => {
        this.setState({ now: strategyNowData });
      })
      .catch(error => {
        console.error('Error desde Strategy', error);
      });
    getStrategyRecent()
      .then(strategyData => {
        this.setState({ recent: strategyData });
      })
      .catch(error => {
        console.error('Error desde Strategy', error);
      });
  }

  selectDate = fromDate => () => {
    this.dateSelected = fromDate;
    getStrategy(fromDate)
      .then(strategyNowData => {
        this.setState({ now: strategyNowData });
      })
      .catch(error => {
        console.error('Error desde Strategy', error);
      });
  };

  clickTitle = () => {
    this.forceUpdate();
    this.componentDidMount();
  };

  render() {
    const { history } = this.props;
    const { recent, now } = this.state;

    moment.locale('es');
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header history={history} />

        <StyledBoxInside>
          <StyledTitleWidget
            title="Strategy"
            type="audiencesradio"
            icon={Audiencias}
            small
            onClick={this.clickTitle}
          />
          <StyledWrapper>
            <SearchByDate
              day={moment().format('DD')}
              month={moment().format('MMMM')}
              weekday={moment().format('dddd')}
              onClick={this.selectDate}
            />
          </StyledWrapper>
          <StyledWrapper>
            <Strategy
              key="1"
              dataList={now}
              defaultTextForNow={defaultTextForNow}
              title={`Strategy del ${moment(this.dateSelected).format(
                'DD-MM-YYYY'
              )}`}
            />
          </StyledWrapper>
          <StyledWrapper>
            {recent && recent.length > 0 && (
              <Strategy key="2" dataList={recent} title="Los más recientes" />
            )}
          </StyledWrapper>
        </StyledBoxInside>
      </div>
    );
  }
}

StrategyPage.propTypes = {
  author: PropTypes.shape({
    user: PropTypes.shape({ name: PropTypes.string }),
    association: PropTypes.shape({ name: PropTypes.string })
  })
};

export default StrategyPage;
